<script setup>
import { computed, inject, onBeforeUnmount, watch } from 'vue'
import TabTeam from './TabTeam.vue'
import TabForm from './TabForm.vue'
import Tabs from '@/__core__/components/navigation/tabs/Tabs.vue'
import useTabNavigation from '@/__core__/composables/useTabNavigation'

const props = defineProps({
  rawData: Object
})

const status = inject('status')
const langId = inject('langId', '')
const width = inject('width')

const navigationFiltered = computed(() => {
  const team = props.rawData?.team || {}
  const { players: playerDataList = [] } = team
  return [
    ...(playerDataList.length ? [{ title: 'standings_team', id: 'team' }] : []),
    { title: 'sm_form', id: 'form' }
  ]
})

const emit = defineEmits(['tab-changed'])

function emitTabClicked(tab) {
  emit('tab-changed', tab)
  changeTab(tab)
}

const { activeTab, changeTab, tabs: navigation, initialize: initTabs } = useTabNavigation(navigationFiltered.value, langId, true)

const teamData = computed(() => {
  const team = props.rawData?.team || {}
  const teamLogo = team.logo?.small || ''
  const teamName = team.name || ''
  const manager = team.manager || {}
  const playerDataList = team.players || []

  return { playerDataList, teamLogo, teamName, manager }
})

const formData = computed(() => {
  const team = props.rawData?.team || {}
  const teamLogo = team.logo?.small || ''
  const teamName = team.name || ''
  const teamNameShort = team.abbreviation || ''
  const { pastMatches: formEntries = [] } = props.rawData
  return { formEntries, teamName, teamLogo, teamNameShort }
})

const unwatch = watch(() => status.value, (newStatus) => {
  if(newStatus === 'success') {
    initTabs(navigationFiltered.value)
  }
})

onBeforeUnmount(unwatch)
</script>

<template>
  <tabs
    :tabs="navigation"
    :tabs-number="navigation.length"
    @tab-clicked="emitTabClicked"
    :classes="'szw-w-full szw-justify-center'"
    class="szw-w-full szw-mx-auto szw-min-h-[32px] szw-max-h-[32px] szw-h-[32px] szw-px-1"
  />
  <TabTeam v-if="activeTab?.id === 'team'" :data="teamData"/>
  <TabForm v-if="activeTab?.id === 'form'" :data="formData" :width="width / 2"/>
</template>
